export default __webpack_public_path__ + "static/media/case1-2.59e4cae4.png";